import { Component, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { LocalService } from '../../../services/shared/local.service';
import { Title } from '@angular/platform-browser';
import { DatePipe } from '@angular/common';
import { FormControl, FormGroup } from '@angular/forms';
import { CmDashboardService } from '../../../services/cm-dashboard.service';
import { CMClubService } from '../../../services/cm-club.service';
import { TeamOfficeService } from '../../../services/team-office.service';
import { UtilityService } from '../../../services/shared/utility.service';
import { CMClub } from '../../../models/cm-general.model';
import { CMClubResponse, CMSite, CMSiteListResponse } from '../../../models/cm-club-service.model';
import { BCMCLPUser, TeamCodes, UserResponse } from '../../../models/clpuser.model';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { ClubContractsTotalFee, CMContractsBySite, CMContractsByUser, CMDashBoardResponse, ClubContractsStatus } from '../../../models/cm-dashboard.modal';
import { RoleFeaturePermissions } from '../../../models/role-container.model';
import { HttpErrorResponse } from '@angular/common/http';
import { GlobalService } from '../../../services/shared/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LineStyle } from '@progress/kendo-angular-charts';

@Component({
    selector: 'app-lm-dashboard',
    templateUrl: './lm-dashboard.component.html',
    styleUrl: './lm-dashboard.component.css'
})
export class LmDashboardComponent {

    public value = 82;
    public animation = true;
    public cashFlowData = [
        {
            period: 'Beginning\\nBalance',
            amount: 15000,
        },
        {
            period: 'Jan',
            amount: 17000,
        },
        {
            period: 'Feb',
            amount: 14000,
        },
        {
            period: 'Mar',
            amount: 12000,
        }
    ];
    public style: LineStyle = "smooth";
    public styleArea: LineStyle = "smooth";
    public categories: string[] = ["Jan", "Feb", "Mar", "Apr", "May"];
    public originalData: any[] = [
        { value: 10 },
        { value: 20 },
        { value: 30 },
        { value: 25 },
        { value: 40 }
    ];
    dataSource = new MatTableDataSource([
        { TotalAmount: '$5000', ContractCount: '10', Avg: '$500' },
    ]);
    dataSourceSite: MatTableDataSource<CMContractsBySite>;
    dataSourceAgent: MatTableDataSource<CMContractsByUser>;
    dataSourceClubFee: MatTableDataSource<ClubContractsTotalFee>;
    dataSourceStatus: MatTableDataSource<ClubContractsStatus>;

    displayedColumns: string[] = ['totalContractFeePaid', 'cMContractCounts', 'avg'];
    displayedColumnsSite: string[] = ['siteName', 'contractCounts'];
    displayedColumnsAgent: string[] = ['userName', 'totalContracts'];
    displayedColumnsStatus: string[] = ['status', 'count'];
    isExpanded = false;
    private encryptedUser: string = '';
    userResponse: UserResponse;
    user: BCMCLPUser;
    roleFeaturePermissions: RoleFeaturePermissions;
    selectedCtDtFilter: number = 1;
    customDateStr: string = '';
    currentRange = new FormGroup({
        start: new FormControl<Date | null>(null),
        end: new FormControl<Date | null>(null),
    });
    selectedCtDtFilterName: string;
    selectedCustomdtStart: string = '';
    selectedCustomdtEnd: string = '';
    customFilter: boolean = false;
    cmDashBoardResponse: CMDashBoardResponse;
    teamSub: Subscription
    routeNameSUb: Subscription
    updateTeamSub: Subscription
    curSiteSub: Subscription
    curTeam: TeamCodes = <TeamCodes>{};
    sites: CMSite[];
    curSite: CMSite = <CMSite>{};
    clpCompanyId: number = 0;
    clubConfig: CMClub;
    private destroy$ = new Subject<void>();

    constructor(private localService: LocalService,
        private titleService: Title,
        private _route: ActivatedRoute,
        private _router: Router,
        private _globalService: GlobalService,
        private datePipe: DatePipe,
        private cmDashboardService: CmDashboardService,
        private clubService: CMClubService,
        private _teamOfficeService: TeamOfficeService,
        private _utilityService: UtilityService,) {

    }

    ngOnInit() {
        this.localService.setShowMenu(true)
        this.localService.setIsCmSite(true);
        this.localService.setRouteName("sm-dashboard");
        this._route.queryParams.pipe(takeUntil(this.destroy$)).subscribe(params => {
            this.encryptedUser = params?.r;
            if (params?.r) {
                this.authenticateR().then(() => {
                    if (this.user) {
                        //localStorage.setItem("token", this.encryptedUser)
                        this._router.navigate(['/cm-dashboard']);
                    }
                    else {
                        this._router.navigate(['/unauthorized']);
                    }
                });
            }
            else {
                this.encryptedUser = localStorage.getItem("token")
                this.authenticateR().then(() => {
                    if (this.user) {
                        this.clpCompanyId = this.user.cLPCompanyID;
                    }
                    else {
                        this._router.navigate(['/unauthorized']);
                    }
                });
            }
        })
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private async authenticateR() {
        await this.localService.authenticateUser(this.encryptedUser)
            .then(async (result: BCMCLPUser) => {
                if (result) {
                    this.user = UtilityService.clone(result);
                    this.clpCompanyId = this.user.cLPCompanyID;
                    this.loadData();
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("navMenu.authenticateR", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async loadData() {
        this.teamSub = this._teamOfficeService.curTeam.pipe(takeUntil(this.destroy$)).subscribe(async (data: any) => {
            if (data != 0 && data != null) {
                this.curTeam = data
                if (this.curTeam?.teamCode > 0) {

                    await this.CMClub_Get();
                    await this.siteSearch();
                }
            }
            else {
                this.curTeam = JSON.parse(localStorage.getItem("curTeam") || "{}")
                if (this.curTeam?.teamCode > 0) {
                    //this.selectedSiteID = 0
                    //this.selectedUserID = 0
                    await this.CMClub_Get();
                    await this.siteSearch();
                }
            }
        })
        this.curSiteSub = this.clubService.curSite.pipe(takeUntil(this.destroy$)).subscribe(async (value: CMSite) => {
            this.curSite = await value
            if (this.curSite == null) {
                this.curSite = await JSON.parse(localStorage.getItem("curSite") || '{}')

            }
            if (this.clubConfig)
                this.CMDashBoard_byClubGet(this.clubConfig?.clubId, 1, this.curSite.siteID);
        })
    }

    async CMClub_Get() {
        if (this.curTeam?.teamCode > 0) {

            await this.clubService.CMClub_Get(this.encryptedUser, this.clpCompanyId, this.curTeam?.teamCode).
                then(async (result: CMClubResponse) => {
                    if (result) {
                        let response = UtilityService.clone(result);
                        this.clubConfig = response?.clubConfig;                        
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._globalService.error("site-fields.clubConfigGet", err.message, null,
                    );
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    async siteSearch() {
        if (this.clubConfig?.clubId > 0) {
            await this.clubService.siteSearch(this.encryptedUser, 0, this.clubConfig?.clubId, 0, 0).
                then(async (result: CMSiteListResponse) => {
                    if (result) {
                        let response = UtilityService.clone(result);
                        this.sites = response?.sites;
                        //if (this.sites.some(s => s.siteID == this.curSite.siteID) == true) {
                        this.CMDashBoard_byClubGet(this.clubConfig.clubId, 1, this.curSite.siteID);
                        //}
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._globalService.error("site-fields.siteSearch", err.message, null,
                    );
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    async CMDashBoard_byClubGet(clubId: number, timeFrame: number, cmSiteID:number) {
        await this.cmDashboardService.CMDashBoard_byClubGet(this.encryptedUser, clubId, timeFrame, cmSiteID, this.selectedCustomdtStart, this.selectedCustomdtEnd)
            .then(async (result: CMDashBoardResponse) => {
                if (result) {
                    this.cmDashBoardResponse = UtilityService.clone(result);
                    if (this.cmDashBoardResponse) {
                        this.cmDashBoardResponse.clubContractsTotalFee.forEach((item) => {
                            if (item.totalContractFeePaid > 0) {
                                let _avg = (+item.totalContractFeePaid / +item.cMContractCounts)
                                item.avg = +_avg.toFixed(2);
                            }
                            else
                                item.avg = 0;
                        });
                        this.bindSite();
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("CmDashboardComponent.CMDashBoard_byClubGet", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    filterDashboard($event) {
        console.log('filterDashboard', $event);
        this.selectedCtDtFilter = $event;
        if ($event == 3)
            this.customFilter = true;
        else
            this.customFilter = false;
        if (!this.customFilter) {
            this.CMDashBoard_byClubGet(this.clubConfig.clubId, this.selectedCtDtFilter,this.curSite.siteID);
        }
    }
    dateRangeChange(dateRangeStart: HTMLInputElement, dateRangeEnd: HTMLInputElement) {
        var startDt = dateRangeStart.value;
        var endDt = dateRangeEnd.value;
        if (startDt) {
            let customdtStart = this.datePipe.transform(startDt, 'MMddyyyy');
            this.selectedCustomdtStart = customdtStart;

        }
        if (endDt) {
            let customdtEnd = this.datePipe.transform(endDt, 'MMddyyyy');
            this.selectedCustomdtEnd = customdtEnd;
            this.selectedCtDtFilter = 3;
            this.selectedCtDtFilterName = "Custom"
            if (this.selectedCustomdtStart && this.selectedCustomdtEnd != null) {
                this.CMDashBoard_byClubGet(this.clubConfig.clubId, this.selectedCtDtFilter, this.curSite.siteID);
            }
        }
    }

    revertCustomFinalizeddtFilter() {
        this.customFilter = false;
        this.selectedCtDtFilter = 1;
        this.selectedCtDtFilterName = "This Month";
        this.CMDashBoard_byClubGet(this.clubConfig.clubId, this.selectedCtDtFilter, this.curSite.siteID);
    }

    bindSite() {
        this.dataSourceSite = new MatTableDataSource(this.cmDashBoardResponse?.cMContractsBySite);
        this.dataSourceAgent = new MatTableDataSource(this.cmDashBoardResponse?.cMContractsByUser);
        this.dataSourceClubFee = new MatTableDataSource(this.cmDashBoardResponse?.clubContractsTotalFee);
        this.dataSourceStatus = new MatTableDataSource(this.cmDashBoardResponse?.clubContractsStatus);
    }
}
